
import React from 'react';
import api from '../utils/api';
import PasswordField from './PasswordField';
import FormField from './common/FormField';
import { useForm } from './common/useForm';

const ForgotPasswordModal = ({ onClose }) => {

  const [step, setStep] = React.useState(1);
  const [form, handleChange, setForm] = useForm({ email: '', code: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = React.useState('');
  const [message, setMessage] = React.useState('');


  const requestCode = async () => {
    setError('');
    setMessage('');
    try {
      await api.post('/auth/forgot-password/request', { email: form.email });
      setMessage('6 оронтой код илгээгдлээ');
      setStep(2);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Код илгээхэд алдаа гарлаа');
    }
  };


  const verifyCode = async () => {
    setError('');
    setMessage('');
    try {
      await api.post('/auth/forgot-password/verify', { email: form.email, code: form.code });
      setMessage('Код баталгаажлаа');
      setStep(3);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Код буруу байна');
    }
  };


  const updatePassword = async () => {
    setError('');
    setMessage('');
    if (form.newPassword !== form.confirmPassword) {
      setError('Нууц үг давталт таарахгүй байна');
      return;
    }
    try {
      await api.post('/auth/forgot-password/reset', { email: form.email, code: form.code, newPassword: form.newPassword });
      setMessage('Нууц үг амжилттай шинэчлэгдлээ');
      setTimeout(onClose, 900);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Шинэчлэх үед алдаа гарлаа');
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h3>Нууц үг сэргээх</h3>
        <div className="form">

          <FormField
            type="input"
            label="И-мэйл"
            name="email"
            typeInput="email"
            placeholder="И-мэйл"
            value={form.email}
            onChange={handleChange}
            required
            disabled={step > 1}
          />
          {step === 1 && <button onClick={requestCode}>Илгээх</button>}

          {step >= 2 && (
            <>
              <FormField
                type="input"
                label="6 оронтой код"
                name="code"
                placeholder="6 оронтой код"
                value={form.code}
                onChange={handleChange}
                maxLength={6}
                required
              />
              {step === 2 && <button onClick={verifyCode}>Код баталгаажуулах</button>}
            </>
          )}

          {step >= 3 && (
            <>
              <PasswordField
                placeholder="Шинэ нууц үг"
                value={form.newPassword}
                onChange={e => handleChange({ target: { name: 'newPassword', value: e.target.value } })}
                autoComplete="new-password"
              />
              <PasswordField
                placeholder="Нууц үг давтах"
                value={form.confirmPassword}
                onChange={e => handleChange({ target: { name: 'confirmPassword', value: e.target.value } })}
                autoComplete="new-password"
              />
              <button onClick={updatePassword}>Шинэчлэх</button>
            </>
          )}

          {error && <p className="error">{error}</p>}
          {message && <p className="success">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
